import type {Nodes} from 'mdast'
import {toMarkdown} from 'mdast-util-to-markdown'

/**
 * Serialize an mdast tree to a Markdown string.
 *
 * NOTE: Does not currently preserve our `delimiter` tokens. For example, an `emphasis` node will always be serialized
 * as `_emphasis_` even if it was originally `*emphasis*`. If we eventually need to preserve the source syntax, we'll
 * want to revisit that.
 */
export function serializeMarkdown(node: Nodes): string {
  let result = toMarkdown(node)
  if (node.type !== 'root') result = result.slice(0, -1) // remove trailing newline the serializer adds
  return result
}
